import React from 'react';
import styles from './Partners.module.scss';

// images
import pt0 from './../../../Assets/images/partners/pt0.jpg';
import pt1 from './../../../Assets/images/partners/pt1.png';
import pt2 from './../../../Assets/images/partners/pt2.png';
import pt3 from './../../../Assets/images/partners/pt3.png';
import pt4 from './../../../Assets/images/partners/pt4.jpg';
import pt5 from './../../../Assets/images/partners/pt5.jpg';
import pt6 from './../../../Assets/images/partners/pt6.png';

import pt7 from './../../../Assets/images/partners/pt7.jpg';
import pt8 from './../../../Assets/images/partners/pt8.jpg';
import pt9 from './../../../Assets/images/partners/pt9.jpg';
import pt10 from './../../../Assets/images/partners/pt10.jpeg';
import pt11 from './../../../Assets/images/partners/pt11.jpg';
import pt12 from './../../../Assets/images/partners/pt12.svg';
import pt13 from './../../../Assets/images/partners/pt13.jpeg';
import pt14 from './../../../Assets/images/partners/pt14.jpg';
import pt15 from './../../../Assets/images/partners/pt15.png';
import pt16 from './../../../Assets/images/partners/pt16.png';
import pt17 from './../../../Assets/images/partners/pt17.png';
import pt18 from './../../../Assets/images/partners/pt18.png';
import pt19 from './../../../Assets/images/partners/pt19.jpg';
import pt20 from './../../../Assets/images/partners/pt20.jpg';



const Partners = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <div className={styles.partners}>
      <div className={styles.title} id='scrollPartners'>Наши заказчики и партнёры</div>
      <div responsive={responsive} className={styles.carousel} id='scrollPartners'>

        <div className={styles.item}>
          <img style={{height: '5rem'}} src={pt19} alt="БФА Девелопмент" />
        </div>

        <div className={styles.item}>
          <img style={{height: '12.5rem'}} src={pt0} alt="Гипростроймост" />
        </div>

        <div className={styles.item}>
          <img style={{height: '6.25rem'}} src={pt8} alt="SetlGroup" />
        </div>

        <div className={styles.item}>
          <img style={{height: '3.125rem'}} src={pt9} alt="Энергоком" />
        </div>

        <div className={styles.item}>
          <img style={{height: '7.5rem'}} src={pt20} alt="БКН Проект" />
        </div>

        <div className={styles.item}>
          <img style={{height: '9.375rem'}} src={pt10} alt="Tigers" />
        </div>

        <div className={styles.item}>
          <img style={{height: '9.375rem'}} src={pt6} alt="ООО «ТрансКомИнжиниринг»" />
        </div>


        <div className={styles.item}>
          <img style={{height: '6.25rem'}}  src={pt3} alt="ООО «БАЛТМОР-проект»" />
        </div>

        <div className={styles.item}>
          <img style={{height: '6.25rem'}}  src={pt11} alt="AVTIN" />
        </div>
  
        <div className={styles.item}>
          <img style={{height: '9.375rem'}} src={pt12} alt="ТрансЭнергоснаб" />
        </div>

        <div className={styles.item}>
          <img style={{height: '12.5rem'}} src={pt13} alt="Сетевые энергетические решения" />
        </div>

        <div className={styles.item}>
          <img style={{height: '9.375rem'}} src={pt14} alt="СЭП" />
        </div>

        <div className={styles.item}>
          <img style={{height: '9.375rem'}} src={pt15} alt="Строймонолит" />
        </div>

        <div className={styles.item}>
          <img style={{width: '9.375rem'}} src={pt7} alt="ООО «Грин Риф»" />
          <i style={{marginBottom: '0.9375rem'}}>ООО «Грин Риф»</i>
        </div>

        <div className={styles.item}>
          <img style={{height: '6.25rem', marginBottom: '3.75rem'}}  src={pt1} alt="ОАО «Ультрамар»" />
        </div>

        <div className={styles.item} style={{fontSize: '2.5rem', width: 'auto', minWidth: 'fit-content'}}>
          <i style={{whiteSpace: 'nowrap'}}>ООО «ТЭС И»</i>
        </div>

        <div className={styles.item}>
          <img style={{height: '7.8125rem'}} src={pt2} alt="ОАО «Хотьковский автомост»" />
        </div>

        <div className={styles.item}>
          <img style={{width: '9.375rem'}} src={pt5} alt="ООО «ПСК «СИТИ-Инжиниринг»" />
          <div className={styles.text}>ООО «ПСК «СИТИ-Инжиниринг»</div>
        </div>

        <div className={styles.item}>
          <img style={{width: '9.375rem'}}  src={pt4} alt="ООО «МТ групп»" />
        </div>

        <div className={`${styles.item} ${styles.largeItem}`}>
          <img style={{height: '5.3125rem'}} src={pt16} alt="ООО «ТрансРегионИнвест»" />
        </div>

        <div className={`${styles.item} ${styles.largeItem}`}>
          <img style={{height: '10.3125rem'}} src={pt17} alt="ООО «Чистый грунт»" />
        </div>

        <div className={`${styles.item} ${styles.largeItem}`}>
          <img style={{height: '9.0625rem'}} src={pt18} alt="ООО «СоюзДонСтрой»" />
        </div>

      </div>
    </div>
  )
}

export default React.memo(Partners);
